import { ConfigProvider, message } from "antd";
import { APP_PREFIX_PATH, AUTH_PREFIX_PATH } from "configs/AppConfig";
import { Redirect, Route, Switch, } from "react-router-dom";
import { getProfileLocal, setUserLocal } from "utils/components";

import Loading from "components/shared-components/Loading";
import { useAuth } from "contexts/useAuth";
import AppLocale from "lang";
import FranchiseeAppLayout from "layouts/app-layout-franchisee/";
import AppLayout from "layouts/app-layout/";
import { useEffect } from "react";
import { useThemeSwitcher } from "react-css-theme-switcher";
import { IntlProvider } from "react-intl";
import Cookies from "universal-cookie";
import AuthLayout from "views/app-views/FranchiseeAdminGlobal/pages/Login";
import { FranchiseeGlobalViews } from "./app-views/FranchiseeGlobal";
import { FranchiseAppViews } from "./app-views/FranchiseViews";
import NotFound from "./auth-views/errors/not-found";
import { PublicViews } from "./public-views/PublicViews";

function RoutePrivate({ children, ...rest }) {
  const auth = useAuth();

  return (
    <Route
      {...rest}
      render={({ location }) =>
        auth.profile ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: AUTH_PREFIX_PATH,
              state: { from: location },
            }}
          />
        )
      }
    />
  );
}

function RouteAuth({ children, ...rest }) {
  const { profile, logout, ...auth } = useAuth();

  return profile ? (
    <Route
      {...rest}
      render={({ location }) => (
        <Redirect
          to={{
            pathname: APP_PREFIX_PATH,
            state: { from: location },
          }}
        />
      )}
    />
  ) : (
    <Route {...rest}>{children}</Route>
  );
}

export const Views = (props) => {
  const { status } = useThemeSwitcher();

  const { location, direction } = props;

  const cookies = new Cookies();
  const { logout, setUser, profile, ...auth } = useAuth();
  const is_panel = profile?.is_panel || getProfileLocal()?.is_panel

  const params = location.search


  function getParamsObject(url) {
    const searchParams = url.substring(url.indexOf("?") + 1);
    const params = searchParams.split("&");

    if (searchParams.length === 0) {
      return null;
    }

    let obj = {};
    params.forEach((param) => {
      const [key, value] = param.split("=");
      obj[key] = value;
    });
    return obj;
  }

  useEffect(() => {


    const allParams = getParamsObject(params);

    const isRedirect = cookies.get("isRedirected");
    if (is_panel) {
      message.error("Você não tem permissão para acessar essa página!");
      setTimeout(() => {
        logout()
      }, 1000)
    }

    if (!!allParams?.user && isRedirect) {
      cookies.remove("isRedirected");
      const profile = getProfileLocal();

      if (profile)
        logout();

      const formattedUser = JSON.parse(decodeURIComponent(allParams.user))

      setUser(formattedUser);
      setUserLocal(formattedUser);

    }




  }, [])


  useEffect(() => {
    if (is_panel) {
      message.error("Você não tem permissão para acessar essa página!");
      setTimeout(() => {
        logout()
      }, 1000)
    }

  }, [location])

  if (location?.pathname.split('/').includes('public')) {

    return <PublicViews />
  }



  if (location?.pathname === '/' && profile) {
    return <Redirect to={'/dashboard'} />
  }


  if (location?.pathname.split('/').includes('mywebsite') && profile) {

    if (profile.type === 0) {
      return <FranchiseeGlobalViews />
    }
    return <FranchiseAppViews />


  }



  if (status === 'loading') {
    return <Loading cover="page" />;
  }





  return (
    <IntlProvider
      locale={"en-us"}
      messages={AppLocale["en"].messages}
      onError={() => false}
    >
      <ConfigProvider direction={direction}>
        <Switch>
          <Route exact path="/404">
            <NotFound />
          </Route>

          <RouteAuth path={AUTH_PREFIX_PATH}>
            <AuthLayout direction={direction} />
          </RouteAuth>


          <RoutePrivate path={APP_PREFIX_PATH}>
            {profile.type === 0 ? (
              <FranchiseeAppLayout location={location} direction={direction} />
            ) : (
              <AppLayout location={location} loading={is_panel} direction={direction} />
            )}
          </RoutePrivate>
        </Switch>
      </ConfigProvider>
    </IntlProvider>
  );
};

export default Views;
